import InfoPage, { linkClass } from "@/components/InfoPage";
import { CONTACT_EMAIL, INSTAGRAM_HANDLE, INSTAGRAM_URL, LEGAL_NAME } from "@/lib/site";

export default function ContactPage() {
  return (
    <InfoPage title="Contact" description={`Contact ${LEGAL_NAME} at ${CONTACT_EMAIL} or on Instagram ${INSTAGRAM_HANDLE}.`} testid="contact-page">
      <div>
        <p className="text-xs uppercase tracking-[0.2em] text-[#8A8A8A]">Email</p>
        <p className="mt-2 text-lg">
          <a data-testid="contact-email" href={`mailto:${CONTACT_EMAIL}`} className={linkClass}>{CONTACT_EMAIL}</a>
        </p>
      </div>
      <div>
        <p className="text-xs uppercase tracking-[0.2em] text-[#8A8A8A]">Instagram</p>
        <p className="mt-2 text-lg">
          <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className={linkClass}>{INSTAGRAM_HANDLE}</a>
        </p>
      </div>
      <p className="text-[#8A8A8A]">{LEGAL_NAME}</p>
    </InfoPage>
  );
}
